import { render, staticRenderFns } from "./chat-message.vue?vue&type=template&id=6c68b388&"
import script from "./chat-message.vue?vue&type=script&lang=js&"
export * from "./chat-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports